import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { isLoaded, isLoading } from "../actions";

//Approve Project/Epic
export async function approveEpic(dispatch,getUser,ideaId,handleClose, PROJECT_APPROVE) {
    dispatch(isLoading());
    try {
      var response = await API.post("manage_epics.php", {
        corp: getUser.corp,
        empId: getUser.empId,
        action: "accept",
        idea_id: ideaId,
        projectId: getUser.projectId
      },{},false);
      if(response.status === 'True') {
        Alert("success", PROJECT_APPROVE);
      }
    } catch (error) {
      Alert('error',error.message);
    }
    handleClose()
    dispatch(isLoaded());
  }